import { Component, OnInit, inject, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ActivatedRoute, Router } from '@angular/router'
import { TranslatePipe } from '../../../core/pipes/translate.pipe'

@Component({
  selector: 'app-pago-completado',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './pago-completado.component.html',
  styleUrl: './pago-completado.component.scss',
})
export class PagoCompletadoComponent implements OnInit {
  private route = inject(ActivatedRoute)
  private router = inject(Router)

  status = signal<'succeeded' | 'failed' | 'pending' | null>(null)

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap
    console.log('[PagoCompletado] query params:', Object.fromEntries(params.keys.map((k) => [k, params.get(k)])))
    const redirectStatus = params.get('redirect_status')
    const paymentIntent = params.get('payment_intent')

    if (redirectStatus === 'succeeded') {
      this.status.set('succeeded')
    } else if (redirectStatus === 'failed') {
      this.status.set('failed')
    } else if (paymentIntent && !redirectStatus) {
      this.status.set('succeeded')
    } else {
      this.status.set('pending')
    }
  }
}
